import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => {
  return {
    dialogPaper: {
      width: 444,
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[16]
    },
    dialogContent: {
      display: "flex",
      padding: "0 24px 20px 24px",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "24px",
      alignSelf: "stretch",
    },
    list: {
      paddingLeft: theme.spacing(3),
      margin: 0,
    },
    dialogActions: {
      display: "flex",
      padding: "8px",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "8px",
      alignSelf: "stretch",
    },
    dialogButton: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingTop: theme.spacing(0.75),
      paddingBotton: theme.spacing(0.75),
      textTransform: "uppercase",
      fontWeight: 500,
    },
    dialogTypography: {
      color: "var(--text-primary, rgba(0, 0, 0, 0.87))",
      fontFeatureSettings: "'liga' off, 'clig' off",
      /* typography/body1 */
      fontFamily: "Inter",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "150%",
      letterSpacing: "0.15px",
    }
  };
});
